const ROLE_ID_STYTCH_MEMBER = 'stytch_member';
const ROLE_ID_STYTCH_ADMIN = 'stytch_admin';

export { ROLE_ID_STYTCH_ADMIN, ROLE_ID_STYTCH_MEMBER };
//# sourceMappingURL=roles.mjs.map
